import { z } from "zod";

export const AlertOpSchema = z.enum(["<", "<=", ">", ">=", "==", "!="]);
export type AlertOp = z.infer<typeof AlertOpSchema>;

export const ChannelTypeSchema = z.enum([
  "email",
  "teams",
  "pagerduty",
  "webhook",
]);
export type ChannelType = z.infer<typeof ChannelTypeSchema>;

export const AlertChannelSchema = z.object({
  type: ChannelTypeSchema,
  target: z.string(),
});
export type AlertChannel = z.infer<typeof AlertChannelSchema>;

export const AlertConditionSchema = z.object({
  metric: z.string(),
  op: AlertOpSchema,
  threshold: z.number(),
  windowMinutes: z.number().min(1).max(1440),
});
export type AlertCondition = z.infer<typeof AlertConditionSchema>;

export const AlertSchema = z.object({
  id: z.string(),
  orgId: z.string(),
  ownerId: z.string(),
  name: z.string(),
  source: z.string(),
  condition: AlertConditionSchema,
  channels: z.array(AlertChannelSchema),
  enabled: z.boolean(),
  createdAt: z.string(),
});
export type Alert = z.infer<typeof AlertSchema>;

export const AlertsListSchema = z.array(AlertSchema);
export type AlertsList = z.infer<typeof AlertsListSchema>;

export const CreateAlertBodySchema = z.object({
  name: z.string().min(1).max(120),
  source: z.string(),
  condition: AlertConditionSchema,
  channels: z.array(AlertChannelSchema).min(1),
  enabled: z.boolean().optional(),
});
export type CreateAlertBody = z.infer<typeof CreateAlertBodySchema>;

export const UpdateAlertBodySchema = CreateAlertBodySchema.partial();
export type UpdateAlertBody = z.infer<typeof UpdateAlertBodySchema>;
